<template>
    <div class="components-order-offer-meal box is-width-100 p-2" v-if="visible" :class="{'has-background-success-light': amount > 0}">

      <a class="components-order-offer-meal__image" v-if="offerMeal.image_thumbnail" @click="configure()">
          <img :src="offerMeal.image_thumbnail" :alt="offerMeal.name"/>
      </a>

      <div class="components-order-offer-meal__content py-1 px-2 is-flex is-flex-direction-column is-height-100 is-justify-content-space-between">
          <div class="mb-0">
            <h4 class="is-size-6 has-text-black has-text-weight-bold mb-0">
                <span v-if="amount > 0" class="has-text-success">{{ amount }}x</span>
                {{ offerMeal.name }}
            </h4>
            <p class="is-size-7 mt-1 mb-0" v-if="offerMeal.portion">
              {{ offerMeal.portion }}
            </p>
            <p v-if="offerMeal.description" class="has-text-grey mt-1 mb-0 is-size-6">
              {{ offerMeal.description }}
            </p>

            <div
              v-for="ingredientGroup in offerMeal.ingredient_groups"
              :key="ingredientGroup.id"
              v-if="hasIngredientGroup(ingredientGroup)"
            >
              <p class="is-size-6 mt-1 has-text-weight-bold">
                {{ ingredientGroup.question }}
              </p>
              <div v-for="ingredient in ingredientGroup.ingredients" :key="ingredient.id" v-if="hasIngredient(ingredientGroup, ingredient)">
                <div class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center mt-0">
                  <p class="is-size-6">{{ ingredient.name }}</p>
                </div>
              </div>
            </div>

          </div>

          <div class="level is-mobile mt-2">
              <div class="level-left">

                <span class="level-item" v-if="offerMeal.price > 0">
                  <span class="has-text-weight-bold" :class="{
                    'has-text-success': amount > 0,
                    'has-text-black': amount === 0
                  }">{{ price }}</span>
                  <span
                      v-if="offerMeal.packaging_price"
                      class="tooltip is-tooltip-bottom mx-3"
                      :class="{'has-text-grey-light': amount === 0, 'has-text-success': amount > 0}"
                      :data-tooltip="'+ ' + packagingPrice"
                  >
                    <span class="icon icon--2"><i class="fas fa-box-open"></i></span>
                  </span>
                </span>

                <div class="buttons level-item">
                  <div class="is-flex is-align-items-center is-flex-direction-row mb-2">

                    <a
                        v-if="!soldOut && offerMeal.price > 0 && offerMeal.ingredient_groups.length === 0"
                        class="button is-small is-success mb-0"
                        :class="{'is-light': amount === 0}"
                        @click="add"
                    >
                      <span class="icon icon--cart"><i class="fas fa-plus"></i></span>
                      <span>Přidat</span>
                    </a>

                    <a
                        v-if="!soldOut && offerMeal.price > 0 && offerMeal.ingredient_groups.length > 0"
                        class="button is-small is-success mb-0"
                        :class="{'is-light': amount === 0}"
                        @click="configure"
                    >
                      <span class="icon icon--cart"><i class="fas fa-shopping-cart"></i></span>
                      <span v-if="cartLine">Upravit</span>
                      <span v-else>Objednat</span>
                    </a>

                    <button v-if="offerMeal.price <= 0" class="button is-small mb-0" disabled>Nelze objednat</button>
                    <button v-if="soldOut" class="button is-small mb-0" disabled>Položka je nedostupná</button>

                    <a v-if="offerMeal.ingredient_groups.length === 0 && amount > 0" class="button is-small is-white mb-0 ml-2" @click="remove">
                      <span class="icon icon--cart"><i class="fas fa-trash"></i></span>
                      <span>Odebrat</span>
                    </a>

                  </div>

                </div>
              </div>

          </div>

      </div>

    </div>
</template>

<script>
import cartActions from '../../../store/web/cart/action-types';
import cartGetters from '../../../store/web/cart/getter-types';
import offerMealModalActions from '../../../store/web/offerMealModal/action-types';

export default {
  props: [
    'alwaysVisible',
    'offerMealProps',
    'soldOutProps'
  ],
  data() {
    return {
      offerMeal: this.offerMealProps,
      soldOut: this.soldOutProps,
    }
  },
  methods: {
    updateOfferMeal(amount) {
      this.$store.dispatch('cart/' + cartActions.UPDATE_OFFER_MEAL, {
        offerMeal: this.offerMeal,
        amount: amount,
        ingredients: {}
      }).then(({offerMeal, soldOut}) => {
        this.offerMeal = offerMeal;
        this.soldOut = soldOut;
      });
    },
    add() {
      let amount = 1;
      if (this.cartLine) amount = this.cartLine.amount + 1;
      this.updateOfferMeal(amount);
    },
    remove() {
      let amount = 1;
      if (this.cartLine) amount = this.cartLine.amount - 1;
      this.updateOfferMeal(amount);
    },
    configure() {
      this.$store.dispatch('offerMealModal/' + offerMealModalActions.SHOW, {
        offerMeal: this.offerMeal,
        soldOut: this.soldOut
      });
    },
    hasIngredientGroup(ingredientGroup) {
      if (!this.cartLine) return false;
      return !!this.cartLine.data.ingredients[ingredientGroup.id];
    },
    hasIngredient(ingredientGroup, ingredient) {
      if (!this.hasIngredientGroup(ingredientGroup)) return false;
      return !!this.cartLine.data.ingredients[ingredientGroup.id].find(id => id === ingredient.id);
    }
  },
  computed: {
    cartLine() {
      return this.$store.getters['cart/' + cartGetters.GET_OFFER_MEAL_CART_LINE](this.offerMeal);
    },
    amount() {
      if (!this.cartLine) return 0;
      return this.cartLine.amount;
    },
    visible() {
      if (this.alwaysVisible) return true;
      return this.cartLine;
    },
    price() {
      if (!this.cartLine) return this.offerMeal.price_formatted;
      return this.cartLine.price_formatted;
    },
    packagingPrice() {
      if (this.cartLine) return this.cartLine.packaging_price_formatted;
      return this.offerMeal.packaging_price_formatted;
    },
  }
}
</script>

<style lang="sass">
</style>
